// authSlice.ts
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authService } from "./services/authService";

export interface User {
  user_id: string;
  name: string | null;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  roles: string[];
  write_access_group: string | null;
  has_write_access: boolean;
  role_enforcement: string;
}

interface AuthState {
  user: User | null;
  loading: boolean;
  error: string | null;
}

const initialState: AuthState = {
  user: null,
  loading: false,
  error: null,
};

export const fetchMe = createAsyncThunk("auth/fetchMe", async () => {
  const user = await authService.getMe();
  return user as User;
});

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearAuth(state) {
      state.user = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMe.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMe.fulfilled, (state, action) => {
        state.loading = false;

        const user = action.payload;

        let first: string | null = null;
        let last: string | null = null;

        if (user.name && user.name.includes(",")) {
          const [ln, fn] = user.name.split(",").map((s) => s.trim());
          first = fn;
          last = ln;
        } else if (user.name && user.name.includes(" ")) {
          const parts = user.name.split(" ").filter((s) => s.trim() !== "");
          first = parts[0];
          last = parts.slice(1).join(" ");
        } else {
          first = user.name;
        }

        state.user = {
          ...user,
          first_name: first,
          last_name: last,
        };
      })
      .addCase(fetchMe.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to load user";
      });

},
});

export const { clearAuth } = authSlice.actions;
export default authSlice.reducer;
